<template>
  <div class="home-wrap">
    <!-- 固定头部区域 -->
    <el-dialog
      title="设置价格浮动"
      :visible.sync="floatDialogVisible"
      width="360px"
    >
      <el-form :model="floatForm" ref="floatForm" label-width="80px">
        <el-form-item label="浮动数值" prop="value">
          <el-input-number
            v-model.number="floatForm.value"
            :min="-0.5"
            :max="0.5"
            :step="0.1"
            placeholder="请输入浮动值"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <div style="color:#999;font-size:12px;">
          最终价格 = 原始价格 + 浮动值<br>
          范围：-0.5 ~ 0.5，默认：不浮动
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="floatDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmCopy">确认复制</el-button>
      </div>
    </el-dialog>

    <div class="fixed-header">
      <div class="home-container">
        <div class="header-content">
          <div class="header-left">
            <div class="header-icon">📊</div>
            <div class="header-text">
              <h1 class="header-title">
                {{ selectDate ? selectDate.slice(5) : '今日' }}
                <span class="title-accent" @click="goToLogin">价格</span>
                <span class="title-dot">·</span>
                <span class="title-date">{{ selectDate }}</span>
              </h1>
            </div>
          </div>
          <div class="header-actions">
            <el-date-picker
              v-model="selectDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              prefix-icon="el-icon-date"
              class="date-picker"
              @change="getList"
              :clearable="false"
            >
            </el-date-picker>
            <el-button 
              size="small" 
              icon="el-icon-refresh"
              @click="getList"
              class="refresh-btn"
            >刷新</el-button>
            <!-- <el-button
              size="small"
              icon="el-icon-user"
              @click="goToLogin"
              class="login-btn"
            >管理</el-button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 可滚动内容区域 -->
    <div class="scroll-content">
      <div class="home-container">
        <!-- 小刀价格 -->
        <div class="card card-xiaodao">
          <div class="card-header">
            <div class="card-header-left">
              <span class="card-title">小刀价格</span>
              <el-badge :value="list.length" :hidden="list.length === 0" class="card-badge" />
            </div>
            <div class="card-header-right">
              <span class="card-total">共 {{ list.length }} 条</span>
              <el-button 
                type="success" 
                size="small" 
                icon="el-icon-document-copy"
                @click="openFloatDialog('xiaodao')"
                :loading="copyLoading"
                class="copy-btn"
              >复制模板</el-button>
            </div>
          </div>

          <div v-loading="loading" class="data-list">
            <template v-if="!loading && list.length === 0">
              <div class="empty-state">
                <div class="empty-icon">📭</div>
                <div class="empty-text">{{ selectDate ? '当天没有数据' : '今日暂无数据' }}</div>
              </div>
            </template>

            <template v-else>
              <div>
                <div class="time-buttons">
                  <button
                    v-for="(item, index) in list"
                    :key="item.id"
                    class="time-btn"
                    :class="[
                      { active: selectedId === item.id },
                      { latest: index === 0 }
                    ]"
                    @click="selectItem(item.id)"
                  >
                    {{ formatTime(item.submit_time) }}
                    <span v-if="index === 0" class="latest-badge">当前</span>
                  </button>
                </div>

                <div v-if="selectedItem" class="data-item expanded">
                  <div class="data-detail">
                    <div class="detail-grid">
                      <div
                        v-for="(detail, idx) in parseDetails(selectedItem.content)"
                        :key="idx"
                        class="detail-item"
                      >
                        <span class="detail-label">{{ detail.label }}</span>
                        <span 
                          class="detail-value" 
                          :class="{
                            'value-changed': parseDetails(list[list.length - 1].content)[idx]?.value !== detail.value
                          }"
                        >{{ detail.value }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- 星悦价格 -->
        <div class="card card-xingyue">
          <div class="card-header">
            <div class="card-header-left">
              <span class="card-title">星悦价格</span>
              <el-badge :value="list1?.length" :hidden="list1?.length === 0" class="card-badge" />
            </div>
            <div class="card-header-right">
              <span class="card-total">共 {{ list1?.length || 0 }} 条</span>
              <el-button 
                type="success" 
                size="small" 
                icon="el-icon-document-copy"
                @click="openFloatDialog('xingyue')"
                :loading="copyLoading"
                class="copy-btn"
              >复制模板</el-button>
            </div>
          </div>

          <div v-loading="loading" class="data-list">
            <template v-if="!loading && !list1?.length">
              <div class="empty-state">
                <div class="empty-icon">📭</div>
                <div class="empty-text">{{ selectDate ? '当天没有数据' : '今日暂无数据' }}</div>
              </div>
            </template>

            <template v-else>
              <div>
                <div class="time-buttons">
                  <button
                    v-for="(item, index) in list1"
                    :key="item.id"
                    class="time-btn"
                    :class="[
                      { active: selectedId1 === item.id },
                      { latest: index === 0 }
                    ]"
                    @click="selectItem1(item.id)"
                  >
                    {{ formatTime(item.submit_time) }}
                    <span v-if="index === 0" class="latest-badge">当前</span>
                  </button>
                </div>

                <div v-if="selectedItem1" class="data-item expanded">
                  <div class="data-detail">
                    <div class="detail-grid">
                      <div v-for="(detail, idx) in parseDetails(selectedItem1.content)" :key="idx">
                        <div class="detail-item">
                          <span class="detail-label">{{ detail.label }}</span>
                          <span 
                            class="detail-value"
                            :class="{
                              'value-changed': parseDetails(list1[list1.length - 1]?.content)[idx]?.value !== detail.value
                            }"
                          >{{ detail.value }}</span>
                        </div>
                        <div v-if="detail.info" class="detail-info">
                          {{ detail.info }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- GBO价格 -->
        <div class="card card-gbo">
          <div class="card-header">
            <div class="card-header-left">
              <span class="card-title">GBO价格</span>
              <el-badge :value="list2?.length" :hidden="list2?.length === 0" class="card-badge" />
            </div>
            <div class="card-header-right">
              <span class="card-total">共 {{ list2?.length || 0 }} 条</span>
            </div>
          </div>

          <div v-loading="loading" class="data-list">
            <template v-if="!loading && !list2?.length">
              <div class="empty-state">
                <div class="empty-icon">📭</div>
                <div class="empty-text">{{ selectDate ? '当天没有数据' : '今日暂无数据' }}</div>
              </div>
            </template>

            <template v-else>
              <div>
                <div class="time-buttons">
                  <button
                    v-for="(item, index) in list2"
                    :key="item.id"
                    class="time-btn"
                    :class="[
                      { active: selectedId2 === item.id },
                      { latest: index === 0 }
                    ]"
                    @click="selectItem2(item.id)"
                  >
                    {{ formatTime(item.submit_time) }}
                    <span v-if="index === 0" class="latest-badge">当前</span>
                  </button>
                </div>

                <div v-if="selectedItem2" class="data-item expanded">
                  <div class="data-detail">
                    <div class="detail-grid">
                      <div
                        v-for="(detail, idx) in parseDetails(selectedItem2.content)"
                        :key="idx"
                        class="detail-item"
                      >
                        <span class="detail-label">{{ detail.label }}</span>
                        <span class="detail-value">{{ detail.value }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// ... (script 部分保持不变)
import request from '@/utils/request'

const labelModeMap = {
  "普通": "qq",
  "加速": "fast",
  "超速": "sup",
  "极速": "very",
  "秒拉": "ml",
  "直拉": "zl",
  "怪额": "odd",
  "超怪": "cg",
  "微信通额": "bz",
  "速额": "se",
  "微信固额": "ge",
  "微信小额": "xe",
  "点额": "de",
  "微信扫码通额": "qr",
  "微信扫码固额": "sg",
  "微信扫码小额": "sx"
}

function getToday() {
  const date = new Date()
  const y = date.getFullYear()
  const m = (date.getMonth() + 1).toString().padStart(2, '0')
  const d = date.getDate().toString().padStart(2, '0')
  return `${y}-${m}-${d}`
}

function timeToSecond(timeStr) {
  const [h, m, s] = timeStr.split(':').map(Number)
  return h * 3600 + m * 60 + s
}

function secondToTime(totalSec) {
  let sec = totalSec
  const h = Math.floor(sec / 3600)
  sec = sec % 3600
  const m = Math.floor(sec / 60)
  const s = sec % 60
  return [h, m, s].map(v => String(v).padStart(2, '0')).join(':')
}

function subOneSecond(timeStr) {
  const total = timeToSecond(timeStr)
  const newTotal = total - 1
  if (newTotal < 0) return '00:00:00'
  return secondToTime(newTotal)
}

export default {
  name: 'HomeIndexPage',
  data() {
    return {
      floatDialogVisible: false,
      floatForm: { value: 0 },
      floatRules: {
        value: [
          { required: true, message: '请输入浮动值', trigger: 'blur' },
          { min: -0.5, max: 0.5, message: '范围在 -0.5 ~ 0.5 之间', trigger: 'blur' }
        ]
      },
      list: [],
      list1: [],
      list2: [],
      selectDate: getToday(),
      loading: false,
      copyLoading: false,
      selectedId: null,
      selectedId1: null,
      selectedId2: null,
      copyTarget: ''
    }
  },
  mounted() {
    console.log('%c\n    -----     -----\n  --------- ---------\n ---------作者---------\n --------Askook--------\n    ---------------\n      -----------\n        -------\n          ---\n           -', 'color:#ff69b4; font-size:16px; font-weight:bold');
    this.getList()
    console.log('%chttps://askook.cn', 'color:#ff69b4; font-size:14px; font-weight:bold; text-decoration:underline; cursor:pointer;');
  },
  computed: {
    selectedItem() {
      return this.list.find(item => item.id === this.selectedId)
    },
    selectedItem1() {
      return this.list1.find(item => item.id === this.selectedId1)
    },
    selectedItem2() {
      return this.list2.find(item => item.id === this.selectedId2)
    }
  },
  methods: {
    openFloatDialog(target) {
      this.copyTarget = target
      this.floatDialogVisible = true
    },

    async commonCopy(text) {
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text)
          return true
        }
        return new Promise(resolve => {
          const textarea = document.createElement('textarea')
          textarea.value = text
          textarea.style.position = 'fixed'
          textarea.style.opacity = '0'
          textarea.style.left = '-9999px'
          document.body.appendChild(textarea)
          textarea.select()
          textarea.setSelectionRange(0, textarea.value.length)
          const result = document.execCommand('copy')
          document.body.removeChild(textarea)
          resolve(result)
        })
      } catch (err){
        console.error('复制异常：', err)
        return false
      }
    },

    async confirmCopy() {
      this.$refs.floatForm.validate(async valid => {
        if (!valid) return
        this.copyLoading = true
        this.floatDialogVisible = false

        try {
          const floatVal = Number((Number(this.floatForm.value) / 100).toFixed(3))
          let sourceList = []
          if (this.copyTarget === 'xiaodao') {
            sourceList = this.list
          } else if (this.copyTarget === 'xingyue') {
            sourceList = this.list1
          }

          if (!sourceList || sourceList.length === 0) {
            this.$message.warning('暂无数据可复制')
            return
          }

          if (this.copyTarget === 'xiaodao') {
            const copyTextList = []
            sourceList.forEach(item => {
              const { content, submit_time } = item
              const detailList = this.parseDetails(content)
              detailList.forEach(d => {
                const label = d.label
                const value = d.value
                const time = submit_time.slice(0, 5)
                let num = (Number(value) / 1000 + floatVal).toFixed(3)
                num = parseFloat(num).toString()
                const line = `${label}${time}/${num}`
                copyTextList.push(line)
              })
            })
            const copyText = copyTextList.join('\n')
            const copyResult = await this.commonCopy(copyText)
            if (copyResult) {
              this.$message.success('复制成功！已应用浮动：' + floatVal)
            } else {
              this.$message.error('复制失败，请手动复制')
            }
          } else if (this.copyTarget === 'xingyue') {
            const sortedList = [...sourceList].sort((a, b) => {
              return a.submit_time.localeCompare(b.submit_time)
            })
            const listLen = sortedList.length
            const segmentArr = []

            for (let i = 0; i < listLen; i++) {
              const cur = sortedList[i]
              const curTime = cur.submit_time
              let start = curTime
              let end = ''

              if (i === 0) {
                start = '00:00:00'
              }

              if (i === listLen - 1) {
                end = '23:59:59'
              } else {
                const nextTime = sortedList[i + 1].submit_time
                end = subOneSecond(nextTime)
              }

              const detailList = this.parseDetails(cur.content)
              const rateMap = {}
              detailList.forEach(d => {
                const mode = labelModeMap[d.label]
                if (!mode) return
                const base = Number(d.value) / 1000
                rateMap[mode] = Number((base + floatVal).toFixed(3))
              })

              segmentArr.push({ start, end, rateMap })
            }

            const merged = {}
            segmentArr.forEach(seg => {
              Object.entries(seg.rateMap).forEach(([mode, rate]) => {
                if (!merged[mode]) {
                  merged[mode] = { speed_mode: mode, time_rates: [] }
                }
                merged[mode].time_rates.push({
                  start_time: seg.start,
                  end_time: seg.end,
                  rate
                })
              })
            })

            Object.values(merged).forEach(item => {
              item.time_rates.sort((a, b) => a.start_time.localeCompare(b.start_time))
            })

            const reqBody = {
              id: null,
              date: this.selectDate,
              rateConfigs: Object.values(merged)
            }

            const fetchStr = `fetch("/api/v1/system/qr-dealers/reckon/configs",{method:"POST",body:JSON.stringify(${JSON.stringify(reqBody)})})
.then(r=>r.json())
.catch(e=>console.error("请求失败:",e));`

            const copyResult = await this.commonCopy(fetchStr)
            if (copyResult) {
              this.$message.success('星悦账单模板复制成功！浮动值：' + floatVal)
            } else {
              this.$message.error('复制失败，请手动复制')
            }
          }
        } catch (err) {
          this.$message.error('复制失败')
          console.error(err)
        } finally {
          this.copyLoading = false
        }
      })
    },

    selectItem(id) {
      this.selectedId = id
    },
    selectItem1(id) {
      this.selectedId1 = id
    },
    selectItem2(id) {
      this.selectedId2 = id
    },
    goToLogin() {
      this.$router.push('/adminLogin')
    },
    
    getDateFromContent(content) {
      if (!content) return ''
      const parts = content.trim().split(/\s+/)
      return parts[0] || ''
    },
    
    parseDetails(str) {
      const normalized = str
        .replace(/\n/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()

      const result = []
      const parts = normalized.split(' ')

      let startIndex = 0
      if (parts.length > 0) {
        const first = parts[0]
        const isTimeOrDate = /^(\d{1,2}[:.]\d{1,2}|(\d{4}[./-]\d{1,2}[./-]\d{1,2}))([\u4e00-\u9fa5]*)$/.test(first)
        if (isTimeOrDate) {
          startIndex = 1
        }
      }

      for (let i = startIndex; i < parts.length; i++) {
        const label = parts[i]
        if (!label) continue

        if (i + 1 >= parts.length) break
        const value = parts[i + 1]

        let info = ''

        const commaMatch = value.match(/^([\d.]+)[，,](.+)$/)
        if (commaMatch) {
          const realValue = commaMatch[1]
          info = commaMatch[2].trim()
          result.push({ label, value: realValue, info })
          i++
          continue
        }

        if (i + 2 < parts.length) {
          const infoPart = parts[i + 2]
          if (/^[,，0-9-]/.test(infoPart)) {
            info = infoPart.replace(/^[,，]/, '').trim()
            i++
          }
        }

        result.push({
          label,
          value: value.replace(/[，,]$/, ''),
          info
        })
        i++
      }

      return result
    },
    
    formatDate(dateStr) {
      if (!dateStr) return ''
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        return dateStr
      }
      try {
        const date = new Date(dateStr)
        if (!isNaN(date.getTime())) {
          const y = date.getFullYear()
          const m = (date.getMonth() + 1).toString().padStart(2, '0')
          const d = date.getDate().toString().padStart(2, '0')
          return `${y}-${m}-${d}`
        }
      } catch (e) {
        console.warn('日期格式化失败', e)
      }
      return dateStr
    },
    
    formatTime(timeStr) {
      if (!timeStr) return ''
      if (/^\d{2}:\d{2}(:\d{2})?$/.test(timeStr)) {
        return timeStr.substring(0, 5)
      }
      try {
        let hour = '', minute = ''
        if (timeStr.includes('T')) {
          const timePart = timeStr.split('T')[1]
          const parts = timePart.split(':')
          hour = parts[0] || '00'
          minute = parts[1] || '00'
        } else if (timeStr.includes(':')) {
          const parts = timeStr.split(':')
          hour = parts[0] || '00'
          minute = parts[1] || '00'
        } else {
          const date = new Date(timeStr)
          if (!isNaN(date.getTime())) {
            hour = date.getHours().toString().padStart(2, '0')
            minute = date.getMinutes().toString().padStart(2, '0')
          }
        }
        return `${hour}:${minute}`
      } catch (e) {
        console.warn('时间格式化失败', e)
      }
      return timeStr.substring(0, 5)
    },
    
    getLatestTime() {
      if (this.list.length === 0) return '暂无'
      const latest = this.list[0]
      return `${latest.submit_time.substring(0, 5)}`
    },

    async getList() {
      this.loading = true
      try {
        const res = await request.post('/todayByDate', {
          date: this.selectDate
        })
        this.list = res.data.xiaodao || []
        this.list1 = res.data.xingyue || []
        this.list2 = res.data.gbo || []
        if (this.list.length) {
          this.selectItem(this.list[0].id)
        } else {
          this.selectedId = ''
        }
        if(this.list1?.length) {
          this.selectedId1 = this.list1[0].id
        } else {
          this.selectedId1 = ''
        }
        if(this.list2?.length) {
          this.selectedId2 = this.list2[0].id
        } else {
          this.selectedId2 = ''
        }
      } catch (err) {
        console.error('请求失败', err)
        this.$message.error('获取数据失败，请稍后重试')
        this.list = []
        this.list1 = []
        this.list2 = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
/* ===== 全局重置 & 基础 ===== */
* {
  box-sizing: border-box;
}

.home-wrap {
  min-height: 100vh;
  background: linear-gradient(135deg, #fdf6f0 0%, #f0f4ff 50%, #faf0f8 100%);
  display: flex;
  flex-direction: column;
}

/* ===== 固定头部 ===== */
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(16px) saturate(180%);
  border-bottom: 1px solid rgba(255, 107, 107, 0.15);
  padding: 10px 0;
}

.fixed-header .home-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-icon {
  font-size: 32px;
  animation: float 3s ease-in-out infinite;
  filter: drop-shadow(0 2px 8px rgba(255, 107, 107, 0.3));
}

.header-text {
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
}

.header-title {
  font-size: 22px;
  font-weight: 800;
  margin: 0;
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
}

.header-title .title-accent {
  background: linear-gradient(135deg, #ff6b6b, #ff8e53);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header-title .title-dot {
  color: #ff6b6b;
  -webkit-text-fill-color: #ff6b6b;
  font-weight: 300;
}

.header-title .title-date {
  font-size: 14px;
  font-weight: 400;
  color: #8892a0;
  -webkit-text-fill-color: #8892a0;
  background: #f0f2f5;
  padding: 2px 12px;
  border-radius: 20px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.date-picker {
  width: 150px;
}

.date-picker >>> .el-input__inner {
  border-radius: 24px;
  height: 36px;
  font-size: 13px;
  border-color: #e8ecf1;
  transition: all 0.3s;
}

.date-picker >>> .el-input__inner:hover,
.date-picker >>> .el-input__inner:focus {
  border-color: #ff8e53;
  box-shadow: 0 0 0 3px rgba(255, 142, 83, 0.15);
}

.refresh-btn {
  border-radius: 24px;
  padding: 6px 18px;
  font-weight: 500;
  color: #ff6b6b;
  border-color: #ffd6d6;
  background: #fff5f5;
  transition: all 0.3s;
}

.refresh-btn:hover {
  background: #ff6b6b;
  color: #fff;
  border-color: #ff6b6b;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(255, 107, 107, 0.35);
}

.login-btn {
  border-radius: 24px;
  padding: 6px 18px;
  font-weight: 500;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  color: #fff;
  transition: all 0.3s;
}

.login-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(102, 126, 234, 0.4);
  color: #fff;
}

/* ===== 滚动内容 ===== */
.scroll-content {
  flex: 1;
  margin-top: 76px;
  overflow-y: auto;
  padding: 20px 24px 40px;
}

.scroll-content .home-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* ===== 卡片 ===== */
.card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  border-radius: 24px;
  padding: 24px 28px;
  margin-bottom: 24px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.card:hover {
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.10);
  transform: translateY(-3px);
}

.card-xiaodao .card-icon {
  color: #ff6b6b;
}

.card-xingyue .card-icon {
  color: #ffc107;
}

.card-gbo .card-header {
  border-bottom-color: rgba(106, 27, 154, 0.2);
}
.card-gbo .card-icon {
  color: #7c3aed;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 14px;
  flex-wrap: wrap;
  gap: 12px;
}

.card-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-icon {
  font-size: 24px;
  line-height: 1;
}

.card-title {
  font-size: 19px;
  font-weight: 700;
  color: #1a1a2e;
  letter-spacing: 0.3px;
}

.card-badge >>> .el-badge__content {
  background: linear-gradient(135deg, #ff6b6b, #ff8e53);
  border: none;
  font-weight: 700;
  font-size: 12px;
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
}

.card-header-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

.card-total {
  font-size: 13px;
  color: #8892a0;
  font-weight: 500;
}

.copy-btn {
  border-radius: 24px;
  font-weight: 600;
  padding: 7px 18px;
  background: linear-gradient(135deg, #56d470, #2ecc71);
  border: none;
  color: #fff;
  transition: all 0.3s;
}

.copy-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(46, 204, 113, 0.4);
  color: #fff;
}

/* ===== 提示条 ===== */
.expand-tip {
  background: linear-gradient(135deg, #fef9f0, #fff5f0);
  border-radius: 14px;
  padding: 10px 18px;
  margin: 14px 0 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #cc7b3e;
  border: 1px solid rgba(255, 193, 7, 0.2);
}

.tip-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffc107, #ff8e53);
  animation: pulse-dot 1.8s ease-in-out infinite;
}

/* ===== 时间按钮 ===== */
.time-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.time-btn {
  position: relative;
  padding: 8px 20px;
  background: #f5f7fb;
  border: 2px solid transparent;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.25s ease;
  font-size: 14px;
  font-weight: 500;
  color: #4a5568;
  font-family: inherit;
  outline: none;
}

.time-btn:hover {
  background: #eef2f7;
  transform: translateY(-1px);
}

.time-btn.active {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  border-color: #667eea;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.35);
}

.time-btn.latest {
  border-color: #ffd93d;
}

.time-btn.latest.active {
  border-color: #ffd93d;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.35), 0 0 0 3px rgba(255, 217, 61, 0.3);
}

.latest-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 9px;
  font-weight: 700;
  background: linear-gradient(135deg, #ffd93d, #ff6b6b);
  color: #fff;
  padding: 1px 8px;
  border-radius: 20px;
  letter-spacing: 0.3px;
}

/* ===== 数据项 ===== */
.data-item {
  background: #fafbfd;
  border-radius: 18px;
  margin-bottom: 8px;
  transition: all 0.3s;
  overflow: hidden;
  border: 1px solid #f0f2f5;
}

.data-item.expanded {
  background: #ffffff;
  border-color: #e8ecf1;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

/* ===== 详情网格 ===== */
.data-detail {
  padding: 16px 18px 18px;
  background: #fafbfd;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 10px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #f0f2f5;
  transition: all 0.2s ease;
}

.detail-item:hover {
  border-color: #d0d5e0;
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.detail-label {
  font-size: 14px;
  color: #6b7280;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.detail-value {
  font-size: 17px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.detail-value.value-changed {
  background: linear-gradient(135deg, #ff6b6b, #ee5a24) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

.detail-info {
  width: calc(100% - 12px);
  margin: -2px auto 6px;
  padding: 5px 14px;
  font-weight: 600;
  font-size: 12px;
  color: #7c3aed;
  background: #f5f0ff;
  border-radius: 0 0 12px 12px;
  border-left: 1px solid #ede9f5;
  border-right: 1px solid #ede9f5;
  border-bottom: 1px solid #ede9f5;
  line-height: 1.5;
}

/* ===== 空状态 ===== */
.empty-state {
  text-align: center;
  padding: 50px 20px;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-text {
  font-size: 17px;
  color: #8892a0;
  font-weight: 500;
}

/* ===== 动画 ===== */
@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-6px) rotate(3deg); }
}

@keyframes pulse-dot {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(0.8); }
}

/* ===== 移动端适配 ===== */
@media (max-width: 768px) {
  .fixed-header {
    padding: 8px 0;
  }
  
  .fixed-header .home-container {
    padding: 0 16px;
  }
  
  .header-content {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  
  .header-left {
    justify-content: center;
  }
  
  .header-title {
    font-size: 18px;
  }
  
  .header-title .title-date {
    font-size: 12px;
    padding: 1px 10px;
  }
  
  .header-icon {
    font-size: 26px;
  }
  
  .header-actions {
    justify-content: center;
  }
  
  .scroll-content {
    margin-top: 100px;
    padding: 14px 14px 30px;
  }
  
  .card {
    padding: 18px 16px;
    border-radius: 18px;
  }
  
  .card-title {
    font-size: 16px;
  }
  
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .card-header-right {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  
  .detail-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 8px;
  }
  
  .detail-item {
    padding: 8px 12px;
  }
  
  .detail-value {
    font-size: 15px;
  }
  
  .time-btn {
    padding: 6px 14px;
    font-size: 13px;
  }
  
  .date-picker {
    width: 130px;
  }
  
  .copy-btn {
    font-size: 12px;
    padding: 5px 14px;
  }
}

@media (max-width: 480px) {
  .scroll-content {
    margin-top: 110px;
    padding: 10px 10px 24px;
  }
  
  .header-title {
    font-size: 16px;
  }
  
  .header-title .title-date {
    font-size: 11px;
    padding: 1px 8px;
  }
  
  .header-icon {
    font-size: 22px;
  }
  
  .card {
    padding: 14px 12px;
    border-radius: 14px;
  }
  
  .detail-grid {
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }
  
  .detail-item {
    padding: 6px 10px;
    border-radius: 10px;
  }
  
  .detail-label {
    font-size: 12px;
  }
  
  .detail-value {
    font-size: 14px;
  }
  
  .time-btn {
    padding: 5px 12px;
    font-size: 12px;
    border-radius: 18px;
  }
  
  .date-picker {
    width: 120px;
  }
  
  .date-picker >>> .el-input__inner {
    font-size: 12px;
    height: 32px;
  }
}
</style>